import { themr } from '@friendsofreactjs/react-css-themr';
import { compose } from 'recompose';
import intlEquipped from '../../../hocs/intlEquipped';

import InvoiceDetailsModal from './InvoiceDetailsModal';

export default compose(
    themr('InvoiceDetailsModal'),
    intlEquipped
)(InvoiceDetailsModal);
